import {Text, View, StyleSheet, Font, Image, } from "@react-pdf/renderer";
import React from "react";
import LatoRegular from "../../Assets/Fonts/Lato-Font/Lato-Regular.ttf";
import LatoBold from "../../Assets/Fonts/Lato-Font/Lato-Bold.ttf";
import Header from "../../Components/GeneratePdf/Header";
import Footer from "../../Components/GeneratePdf/Footer";

Font.register({
  family: "Lato",
  fonts: [
    { src: LatoRegular, fontWeight: 400 },
    { src: LatoBold, fontWeight: 700 },
  ],
});

const styles = StyleSheet.create({
  pagewapper: {
    position: "relative",
    height: "100%",
  },
  content: {
    display: "flex",
    width: "570px",
    alignItems: "left",
  },
  contenttitle: {
    fontFamily: "Lato",
    fontWeight: 700,
    fontSize: "18px",
    lineHeight: "30px",
    color: "#426B88",
  },
  wapper: {
    width: "567px",
    fontFamily: "Lato",
    fontWeight: 400,
    fontSize: "12px",
    lineHeight: "18px",
    color: "#245775",
  },
  mainContent: {
    flexGrow: 1,
    marginTop: "28px",
  },
  footer: {
    marginTop: "auto",
  },
  table: {
    width: "100%",
  },
  tableRow: {
    flexDirection: "row",
    paddingVertical: 2,
    alignItems: "center",
  },
  tableHeader: {
    paddingVertical: 1,
    fontWeight: 400,
    border: "0px",
    backgroundColor: "#245775",
    fontWeight: "bold",
    color: "white",
    borderTopLeftRadius: 4,
    borderTopRightRadius: 4,
  },
  headerCell: { color: "white", fontWeight: 400, paddingVertical: "5px" },
  cellQuestion: {
    width: "70%",
    fontSize: 10,
    color: "#394554",
    fontWeight: 400,
  },
  cellScore: { width: "7%", textAlign: "center", fontSize: 10 },
  cell: {
    padding: "10px",
    textAlign: "left",
  },

  rowEven: {
    backgroundColor: "#F1F3F3",
  },
  rowOdd: {
    backgroundColor: "#FFF",
  },
  redRectangle: {
    width: 17,
    height: 17,
    backgroundColor: "#B6111F",
    borderRadius: "1.34px",
  },
});

const truncateText = (text, limit) => {
  if (text.length <= limit) return text;
  return text.substring(0, text.lastIndexOf(" ", limit)) + "...";
};

const renderRectangle = (value) => {
  return value === 1 ? <View style={styles.redRectangle} /> : null;
};

const LeadershipCollaborativeInFocus360 = (apiData = {}) => {
  console.log("api in LeadershipCollaborativeInFocus360", apiData);
  const respondentName = apiData?.apiData?.fullName?.split(' ')[0] || 'Respondent';
  console.log("respondentName", respondentName)
  // Process questions to replace [First Name] with the actual respondent's name
  const processedQuestions = data.map(item => ({
    ...item,
    question: item.question.replace(/\[First Name\]/g, respondentName)
  }));

  return (
  <View style={styles.pagewapper}>
    <Header />
    <View style={styles.content}>
      <Text style={styles.contenttitle}>COLLABORATIVE LEADERSHIP 360 IN FOCUS</Text>
      <View style={styles.wapper}>
        <Text>
          This chart isolates the items related to Collaborative Leadership based on the OBSERVER ratings (SELF excluded). Focused results reflect the average of observer scores only. The response scale runs from 1 (Least) to 4 (Most). Any unselected statement will appear blank in the In Focus section.
        </Text>
      </View>
    </View>
    <View style={styles.mainContent}>
      <View style={[styles.tableRow, styles.tableHeader]}>
        <Text style={[styles.cell, styles.cellQuestion, styles.headerCell]}>
          Collaborative
        </Text>
        {[1, 2, 3, 4].map((num) => (
          <Text key={num} style={[styles.cell, styles.cellScore, styles.headerCell]} > {num} </Text>
        ))}
      </View>

      {processedQuestions.map((item, index) => (
        <View key={index} style={[ styles.tableRow, index % 2 === 0 ? styles.rowEven : styles.rowOdd, ]} >
          <Text style={[styles.cell, styles.cellQuestion]}>
            {item.question.replace(/\[First Name\]/g, respondentName)}
          </Text>
          {item.scores.map((score, index) => (
            <View key={index} style={[styles.cell, styles.cellScore]}>
              {renderRectangle(score)}
            </View>
          ))}
        </View>
      ))}
    </View>
    <Footer />
  </View>
);
};
export default LeadershipCollaborativeInFocus360;

const data = [
  {
    id: 1,
    quadrant: "Collaborative",
    question: "When leading through conflict, [First Name] is attuned to the feelings everyone is experiencing.",
    scores: [1, 1, 1, 1],
  },
  {
    id: 2,
    quadrant: "Collaborative",
    question: "[First Name] is at their best when feeling deeply connected to others.",
    scores: [1, 1, 1, 1],
  },
  {
    id: 3,
    quadrant: "Collaborative",
    question: "[First Name] wants to build an emotionally intelligent organization.",
    scores: [1, 1, 1, 1],
  },
  {
    id: 4,
    quadrant: "Collaborative",
    question: "[First Name] believes relationships of trust are essential to creating a successful organization.",
    scores: [1, 1, 1, 1],
  },
  {
    id: 5,
    quadrant: "Collaborative",
    question: "[First Name] believes developing a healthy culture is a very high value of their leadership.",
    scores: [1, 1, 1, 0],
  },
  {
    id: 6,
    quadrant: "Collaborative",
    question: "[First Name] is motivated to help the team connect more deeply with each other.",
    scores: [1, 1, 1, 0],
  },
  {
    id: 7,
    quadrant: "Collaborative",
    question: "[First Name] finds satisfaction from developing a collaborative leadership culture.",
    scores: [1, 1, 1, 0],
  },
  {
    id: 8,
    quadrant: "Collaborative",
    question: "[First Name] develops others by gaining buy-in around shared values.",
    scores: [1, 1, 0, 0],
  },
  {
    id: 9,
    quadrant: "Collaborative",
    question: "[First Name] enjoys building an empowering culture at work.",
    scores: [1, 0, 0, 0],
  },
  {
    id: 10,
    quadrant: "Collaborative",
    question: "[First Name] wants the team to be fully engaged in the decision-making process.",
    scores: [1, 0, 0, 0],
  },
];
